import { Formik, Form, Field } from 'formik'
import { isDark } from '../../../../../utils'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useTw } from '../../../../../utils/Styles'
import { useProfile } from '../../../../../utils/Profile'
import { ChevronRightIcon } from '@heroicons/react/outline'
import { SubmitListener } from '../../../../../utils/SubmitListener'

export function KnowledgeBase() {
  const tw = useTw()
  const profile = useProfile()
  const navigate = useNavigate()
  const [t] = useTranslation('common')

  if (!profile?.showKnowledgeBase) {
    return null
  }

  return (
    <div
      className={tw`flex flex-col border-t-2 border-background bg-white p-4 shadow-md rounded`}
    >
      <p className={tw`font-bold text-sm`}>{t('home.kb.title')}</p>
      <Formik
        initialValues={{ search: '' }}
        onSubmit={(values) =>
          values.search &&
          navigate('/kb-search', { state: { search: values.search } })
        }
      >
        <Form className={tw`flex h-14`}>
          <Field
            type="text"
            name="search"
            placeholder={t('home.kb.search_placeholder')}
            className={tw`select-none my-2 w-full rounded-l border-r-0 focus:ring-foreground focus:border-foreground outline-none`}
          />
          <button
            type="submit"
            className={tw`leading-6 px-2 my-2 bg-foreground rounded-r`}
          >
            <ChevronRightIcon
              className={tw`h-6 w-6 ${
                isDark(profile.foreground) ? 'text-white' : 'text-black'
              }`}
            />
          </button>
          <SubmitListener />
        </Form>
      </Formik>
      <button
        onClick={() => navigate('/kb')}
        className={tw`select-none pt-2 ${
          isDark(profile.foreground) ? 'text-foreground' : 'text-black'
        }`}
      >
        {t('home.kb.all_categories')}
      </button>
    </div>
  )
}
